<div class="dashboard-views-table-header">
    <a (click)="showNavOptions = !showNavOptions" class="mobile-link"><em>Table Sort</em><span class="dots"></span></a>

    <ul [ngClass]=" showNavOptions ? 'nav-visible' : ''">
      <li title="Order by ID" class="table-header-id" [ngClass]="{orderup: order == 'id', orderdown: order == '-id'}" (click)="setSort('id')">
          <span><em>Id</em></span>
      </li>
      <li title="Order by Tags" class="table-header-labels" [ngClass]="{orderup: order == 'label', orderdown: order == '-label'}" (click)="setSort('label')">
        <span><em>Tags</em></span>
      </li>
      <li title="Order by Version" class="table-header-version" [ngClass]="{orderup: order == 'origin_version', orderdown: order == '-origin_version'}" (click)="setSort('origin_version')">
        <span><em>Aw Version</em></span>
      </li>
      <!-- maybe user_handler -->
      <li title="Order by Assigned to" class="table-header-assignee" [ngClass]="{orderup: order == 'user_assigned', orderdown: order == '-user_assigned'}" (click)="setSort('user_assigned')">
        <span><em>Assigned To</em></span>
      </li>
      <li title="Order by Due Date" class="table-header-duedate" [ngClass]="{orderup: (order == 'due_date'), orderdown: order == '-due_date'}" (click)="setSort('due_date')">
        <span><em>Due Date</em></span>
      </li>
      <li title="Order by Stage" class="table-header-stage" [ngClass]="{orderup: (order == 'status'), orderdown: order == '-status'}" (click)="setSort('status')">
        <span><em>Stage</em></span>
      </li>
    </ul>
  </div>
